/**
 * Base URL is used to easily switch from . configurations or add any other baseURL to your application
 */
const baseURL = '/'

/**
 * Each file being used by any async-hook within react should be decalred here first
 */
export const fHDRI = baseURL + 'skybox/sample.hdr'
